import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=67e1340b&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QCard,QCardSection,QRadio,QInput,QBtn,QDialog,QKnob} from 'quasar'
component.options.components = Object.assign({QPage,QCard,QCardSection,QRadio,QInput,QBtn,QDialog,QKnob}, component.options.components || {})
